import { Component, OnInit } from '@angular/core';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { Router } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import Swal from 'sweetalert2';
import { UserService } from 'shared/services/User/user.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-choose-season',
  templateUrl: './choose-season.component.html',
  styleUrls: ['./choose-season.component.css']
})
export class ChooseSeasonComponent implements OnInit {
  leagues: any;
  loading: boolean;
  imgProduct = environment.URL_TEAM_IMAGES;

  constructor(
    private inventoryService: SsInventoryService,
    private router: Router,
    private data: DataSharingService,
    private alertService: AlertPopupService,
    private us: UserService
  ) { }

  ngOnInit() {
    this.data.changeTitle('CHOOSE TEAM');
    this.loading = true;
    this.inventoryService.getNewPurchase().subscribe(res => {
      this.leagues = res.products;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.alertService.errorAlertWithResult('Season Not Avaiable', 'Go Back', '/new-group');
    });
  }

  back(){
    this.router.navigateByUrl("/new-group");
  }

  selectTeam(sport) {
    if (sport.vendor_id_fk === '1') {
      if (sport.event_name === 'DEPOSIT') {
        this.router.navigate(['/reservations/create'], { queryParams: { packageId: sport.pk_ss } });
      } else if (sport.event_name == null){
        this.requestCall(sport);
      }
      else {
        this.router.navigate(['/new-group/choose-seats'], { queryParams: { eventName: sport.pk_ss } });
      }
    } else if (sport.vendor_id_fk === '2') {
      // tdc
      this.router.navigate(['/new-group/seat-selection'], { queryParams: { eventName: sport.pk_ss } });
    } else {
      this.alertService.errorAlert('This vendor is not supported');
    }
  }

  requestCall(team){
    Swal.fire({
      imageUrl: `${this.imgProduct}/${team.team_thumb_img}`,
      imageWidth: 100,
      imageAlt: 'Custom image',
      title: `${team.team_name_full} Season Tickets`,
      text: "Enter your phone number to get more details about this season.",
      input: 'text',
      inputPlaceholder: "Phone Number",
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Request a call',
      showLoaderOnConfirm: true,
      preConfirm: (phoneNumber) => {
        let a = (Number.isInteger(Number(phoneNumber)));
        if(a == true){
          this.us.requestGroupInfo(team, phoneNumber).then(res => {
            Swal.fire({
              title: `Thanks! We'll be in touch with you shortly. `,
              type: "success"
            })
            return res;
          }).catch(err => {
            Swal.fire({
              title: `Hmm. Something went wrong. Try again later. `,
              type: "error"
            })
          })
        } else {
          return Swal.fire({
            type: 'warning',
            title: 'Foul!'
          })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/choose-season/choose-season.component.ts